<template>
    <div class="seller-badge-modal-dialog">
        <div class="seller-badge-modal">
            <div class="seller-badge-modal-content" :style="{ width: width, height:height }">
                <section :class="['seller-badge-modal-main', { 'has-footer': footer }]">
                    <header class="modal-header" v-if="header">
                        <slot name="header">
                            <h2>{{ title }}</h2>
                        </slot>

                        <button v-if="showCloseButton" class="modal-close modal-close-link dashicons dashicons-no-alt" @click="$emit('close')">
                            <span class="screen-reader-text">{{ __( 'Close modal panel', 'dokan' ) }}</span>
                        </button>
                    </header>
                    <div class="modal-body">
                        <slot name="body"></slot>
                    </div>
                    <footer class="modal-footer" v-if="footer">
                        <div class="inner">
                            <slot name="footer"></slot>
                        </div>
                    </footer>
                </section>
            </div>
        </div>
        <div class="seller-badge-modal-backdrop"></div>
    </div>
</template>

<script>
export default {

    name: 'Modal',

    props: {
        header: {
            type: Boolean,
            required: false,
            default: true
        },
        footer: {
            type: Boolean,
            required: false,
            default: true
        },
        width: {
            type: String,
            required: false,
            default: '500px'
        },
        height: {
            type: String,
            required: false,
            default: 'auto'
        },
        title: {
            type: String,
            required: true,
            default: ''
        },
        showCloseButton: {
            title: Boolean,
            required: false,
            default: true,
        }
    },

    data () {
        return {

        };
    }
};
</script>

<style lang="less" scoped>
.seller-badge-modal-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    min-height: 360px;
    background: #000;
    opacity: .7;
    z-index: 99900;
}

.seller-badge-modal {
    font-family: "SF Pro Text", sans-serif;

    * {
        box-sizing: border-box;
    }

    .seller-badge-modal-content {
        position: fixed;
        background: #fff;
        z-index: 100000;
        left: 50%;
        top: 50%;
        border-radius: 3px;
        -webkit-transform: translate(-50%,-50%);
        -ms-transform: translate(-50%,-50%);
        transform: translate(-50%,-50%);

        @media (max-width: 767px) {
            width: calc(100% - 20px) !important;
            height: calc(100% - 40px) !important;
        }
    }

    .seller-badge-modal-main {
        padding: 50px 30px 35px;
        border-radius: 3px;

        &.has-footer {
            padding-bottom: 55px;
        }
    }

    .modal-header {
        display: flex;
        margin-bottom: 50px;

        .modal-img {
            width: 50px;
            margin-right: 20px;

            img {
                width: 100%;
            }
        }

        .modal-title {
            h2 {
                font-size: 1.4375rem;
                font-weight: 700;
                line-height: 1em;
                margin: 0 0 10px;
            }

            h3 {
                font-weight: 700;
                font-size: 23px;
            }

            p {
                color: #B3B3B3;
                line-height: 1;
                margin: 0;

                .color-blue{
                    color: #1A9ED4;
                }
            }
        }

        .modal-close-link {
            cursor: pointer;
            color: #777;
            height: 54px;
            width: 54px;
            padding: 0;
            position: absolute;
            top: 0;
            right: 0;
            text-align: center;
            border: 0;
            background-color: transparent;
            -webkit-transition: color .1s ease-in-out,background .1s ease-in-out;
            transition: color .1s ease-in-out,background .1s ease-in-out;

            &::before {
                font: normal 22px/50px dashicons !important;
                color: #1F1F1F;
                display: block;
                content: '\f335';
                font-weight: 300;
            }

            &:hover {
                background: #ddd;
                border-color: #ccc;
                color: #000;
            }
        }
    }
    .modal-sub-title {
        h3 {
            color: #000000;
            font-size: 1rem;
            font-weight: 700;
            line-height: 1.1875em;
            margin: 0 0 12px;
        }
    }
    .modal-body {
        min-height: 100px;
        max-height: calc(100vh - 210px);
        overflow-y: auto;

        .modal-level-box {
            padding: 15px 18px;
            margin-bottom: 15px;
            border-radius: 3px;
            border: 1px solid #e2e2e2;

            &:last-child {
                margin-bottom: 0;
            }
        }

        .level_description {
            display: flex;
            align-items: flex-start;
            gap: 25px;
            color: #000000;
            font-size: 13px;

            .left-content {
                .modal-img {
                    width: 30px;
                    height: 32px;

                    img {
                        width: 100%;
                    }
                }
                .container {
                    position: relative;
                    text-align: center;
                }
                .bottom-center {
                    position: absolute;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 15px;
                    height: 15px;
                    bottom: 0;
                    left: 2px;
                    font-size: 0.6875rem;
                    font-weight: 500;
                    color: #000;
                    background-color: #fff;
                    border-radius: 50%;
                    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.25);
                    transform: translate(5px, 10px);
                }
            }
            .right-content {
                p {
                    color: #000;
                    font-size: 0.75rem;
                    font-weight: 600;
                    line-height: 1em;
                    margin: 0 0 10px;

                    &:last-child {
                        margin-bottom: 0;
                    }

                    i {
                        color: #c8c8c8;
                        font-size: 0.75rem;
                        margin-left: 3px;

                        &.has-level {
                            color: #139f84;
                        }
                    }
                }
                .no_of_vendor{
                    color: #b3b3b3;
                    font-weight: 400;
                    line-height: 1.25em;
                    .vendor-count{
                        color: #1a9ed4;
                    }
                }
            }
        }
    }

    footer {
        position: absolute;
        left: 0;
        right: 0;
        bottom: -30px;
        z-index: 100;
        padding: 1em 1.5em;
        background: #fcfcfc;
        border-top: 1px solid #dfdfdf;
        -webkit-box-shadow: 0 -4px 4px -4px rgba(0,0,0,.1);
        box-shadow: 0 -4px 4px -4px rgba(0,0,0,.1);

        .inner {
            text-align: right;
            line-height: 23px;
        }
    }
}
</style>
